import { render, staticRenderFns } from "./bloodGlucoseRecord.vue?vue&type=template&id=28f5093e&scoped=true"
import script from "./bloodGlucoseRecord.vue?vue&type=script&lang=js"
export * from "./bloodGlucoseRecord.vue?vue&type=script&lang=js"
import style0 from "./bloodGlucoseRecord.vue?vue&type=style&index=0&id=28f5093e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f5093e",
  null
  
)

export default component.exports